export default {
    path: "/main/booking",
    name: "Booking",
    component: () => import("@/views/Main/Booking/index"),
    // redirect: "/main/Booking/home",
    children: [
    ]
}